import { EditOutlined } from '@ant-design/icons';
import { Button, ButtonProps } from 'antd';
import React from 'react';

export const EditButton: React.FunctionComponent<ButtonProps> = props => {
  return <Button {...props} type="link" shape="default" icon={<EditOutlined />} />;
};
